import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, HashRouter } from 'react-router-dom';
import App from './App';
import { ColorModeProvider } from './context/ColorModeContext';
import './styles/index.css';
import './i18n';

const isElectron = navigator.userAgent.toLowerCase().includes('electron');
const Router = isElectron ? HashRouter : BrowserRouter;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Router>
      <ColorModeProvider>
        <App />
      </ColorModeProvider>
    </Router>
  </React.StrictMode>
);
